// Styled Components
import StyledMain from './StyledMain';
import { StyledImg, ImgContainer } from './StyledImg';
import StyledSection from './StyledSection';
import Form from './QrForm/Form';
// Images
import { BlueQr } from '../images/images';
import StyledHeading from './StyledHeading';
import StyledParagraph from './StyledParagraph';
// Hooks
import { useDataContext } from '../context/useDataContext';
import { useState } from 'react';
const AllInOne = ({ theme }) => {
  const [data, _] = useDataContext();
  const [error, setError] = useState(false);
  return (
    <StyledMain>
      <StyledSection>
        {data && (
          <ImgContainer>
            <StyledImg
              alt="QR code"
              transform="rotate(180deg) scale(150%)"
              width="16rem"
              src={data}
            />
          </ImgContainer>
        )}
        {!data && <StyledImg alt="QR code" width="28.8rem" src={BlueQr} />}
        <StyledHeading>
          {!data
            ? 'Improve your front-end skills by building projects'
            : 'QR Generated by David Morgade code generator!'}
        </StyledHeading>
        <StyledParagraph>
          {!data
            ? 'Scan the QR code to visit Frontend Mentor and take your coding skills to the next level'
            : 'If you are using Firefox browser, right click on the screen and select take a screenshot to get a screenshot'}
        </StyledParagraph>
      </StyledSection>
      <Form error={error} theme={theme} setError={setError} />
    </StyledMain>
  );
};

export default AllInOne;
